<template>
  <tr>
    <td class="align-middle" style="width: 240px;">
      {{ handlerData.name }}
    </td>
    <td class="align-middle" style="width: 180px;">
      <a
        v-if="!handlerData.airport_phone"
        :href="'tel:' + handlerData.phone">
        <small>{{ handlerData.phone }}</small>
      </a>
      <a
        v-if="handlerData.airport_phone"
        :href="'tel:' + handlerData.airport_phone">
        <small>{{ handlerData.airport_phone }}</small>
      </a>

      <i
        class="material-icons text-primary ml-2 edit-handler-phone"
        @click.prevent="editHandlerPhone">
        edit
      </i>
    </td>
    <td class="align-middle" style="width: 160px;">
      <a :href="'mailto:' + handlerData.phone">
        <small>{{ handlerData.email }}</small>
      </a>
    </td>
    <td class="align-middle">
      <small>{{ handlerData.notes }}</small>
    </td>
    <td style="width: 160px;" class="align-middle">
      <span class="text-primary" v-if="handlerData.is_default">Preferred handler</span>
      <a href="#" class="text-secondary" v-else @click.prevent="setDefaultHandler">
        <template v-if="!defaultInProgress">Set as preferred</template>
        <template v-else>Saving...</template>
      </a>
    </td>
    <td style="width: 140px;" class="align-middle">
      <d-button
        theme="danger"
        :disabled="removeInProgress"
        @click.prevent="removeHandler"
        title="Delete">
        <i class="material-icons">delete</i>
      </d-button>
    </td>
  </tr>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import ListUtils from './../../utils/ListUtils.js';

export default {
  name: 'handlers-list-item',
  props: {
    handlerData: {
      type: Object,
      default: () => ({}),
      required: true
    },
    referenceType: {
      type: String,
      required: true
    },
    referenceId: {
      type: Number,
      default: 0,
      required: true
    }
  },
  data () {
    return {
      defaultInProgress: false,
      removeInProgress: false
    };
  },
  methods: {
    removeHandler () {
      this.removeInProgress = true;
      let endpointBase = '';

      if (this.referenceType === 'COUNTRY') {
        endpointBase = 'countries';
      } else if (this.referenceType === 'AIRPORT') {
        endpointBase = 'airports';
      }

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: endpointBase + '/delete-handler/' + parseInt(this.referenceId, 10),
        idKey: 'handler_id',
        idValue: parseInt(this.handlerData.id, 10),
        successTitle: 'Item removed',
        successText: 'The selected item has been removed',
        confirmTitle: 'Do you really want to remove this item?',
        confirmText: 'This operation cannot be reverted',
        errorTitle: 'An error occurred',
        errorText: 'Please try again.',
        successAction: () => {
          this.removeInProgress = false;
          this.$bus.$emit('handlers-list-reload');
        },
        cancelAction: () => {
          this.removeInProgress = false;
        },
        errorAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    setDefaultHandler () {
      if (this.defaultInProgress) {
        return;
      }

      this.defaultInProgress = true;

      let endpointURL = '/airports/set-default-handler/' + parseInt(this.referenceId, 10);

      if (this.referenceType === 'COUNTRY') {
        endpointURL = '/countries/set-default-handler/' + parseInt(this.referenceId, 10);
      }

      FormUtils.submitInBackground({
        $http: this.$http,
        endpoint: endpointURL,
        formData: {
          handler_id: parseInt(this.handlerData.id, 10)
        },
        errorTitle: 'An error occurred',
        errorText: 'An error occurred during changing default han. Please try again.',
        successAction: () => {
          this.defaultInProgress = false;
          this.$bus.$emit('handlers-list-reload');
        }
      });
    },
    editHandlerPhone () {
      this.$bus.$emit('show-handler-phone-popup', {
        handler_id: parseInt(this.handlerData.id, 10),
        airport_id: parseInt(this.referenceId, 10),
        phone: this.handlerData.airport_phone ? this.handlerData.airport_phone : this.handlerData.phone
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-handler-phone {
  cursor: pointer;
}
</style>
